const data = [
    {
        id: 1,
        name: 'Dwayne Johnson',
        prof: 'Actor',
        img: 'https://www.varietyinsight.com/images/honoree/Dwayne_Johnson.png',
        exp: 'He’s one of Hollywood’s highest paid actors, but “The Rock” recently opened up about depression to the Express, a British newspaper. “Struggle and pain is real,” said Johnson, who saved his mother from a suicide attempt when he was 15.  “Depression never discriminates,” he tweeted later. “Took me a long time to realize it but the key is to not be afraid to open up. Especially us dudes have a tendency to keep it in. You’re not alone.”'
    },
    {
        id: 2,
        name: 'Katy Perry',
        prof: 'Pop Singer',
        img: 'https://purepng.com/public/uploads/large/51509906287f0pcjaogrgya5rhumjfdpcbeoadiwsiin3cg3ezleddh6mmqu4v3truhmkyjely4fnyezbstiupkjypfnbao8faoyyg4sfxccvrv.png',
        exp: 'The pop star shared her struggles with depression during a 96-hour livestream on YouTube. In an emotional session with Siri Sat Nam Singh, host of the Viceland channel’s The Therapist, Perry said she opened up because she wanted her fans to see her true self. "If people can see that I\'m just like them, they can dream just as big."'
    },
    {
        id: 3,
        name: 'Michael Phelps',
        prof: 'Swimmer',
        img: 'https://resources.fina.org/photo-resources/2021/01/27/1b14ebc0-1285-4115-9aa3-4ac9a7cb5a08/a45d5263-a0f0-4910-87e0-bc7589d36a54?width=350',
        exp: 'The swimmer who’s won 28 Olympic medals said his first “depression spell” happened in 2004, but his lowest point came after the 2012 Games, according to CNN. Phelps said he sat alone in his bedroom for 3 to 5 days “not wanting to be alive,” and he knew he needed help. After he sought treatment and started talking about his feelings, he said “life became easy.” Now he understands that “it’s OK to not be OK.”'
    },
    {
        id: 4,
        name: 'J.K. Rowling',
        prof: 'Author',
        img: 'https://variety.com/wp-content/uploads/2019/12/jk_rowling_v3.png',
        exp: 'The woman behind Harry Potter brought joy to millions, but admits she felt despair while writing the magical novels. Her dark moods even inspired her series’ soul-sucking creatures known as Dementors. “It\'s so difficult to describe [depression] to someone who\'s never been there, because it\'s not sadness,” she told Oprah Winfrey in 2010. “But it\'s that cold absence of feeling -- that really hollowed-out feeling.” '
    },
    {
        id: 5,
        name: 'Lady Gaga',
        prof: 'Pop Singer',
        img: 'https://www.varietyinsight.com/images/honoree/Lady_Gaga.png',
        exp: 'The pop star, whose hits include "Paparazzi” and “Poker Face,” says she’s dealt with both depression and anxiety her whole life. Gaga isn\'t ashamed to admit she takes medication for depression. In an interview with Billboard magazine, she said she thinks it’s important for people to talk about their mental health. “If we share our stories and stick together, we’re stronger.”'
    }
]

export default data;